import React from 'react';
import { Chip, Grid, Stack, Typography } from 'ui';

export const MatchedPriceOverview = ({
  prices,
}: {
  prices: {
    label: string;
    price?: string;
  }[];
}) => {
  return (
    <Stack direction="column" gap={1.5}>
      <Grid container spacing={1} alignItems="center">
        {prices.map(({ price, label }) => (
          <React.Fragment key={label + price}>
            <Grid item xs={7}>
              <Typography variant="body2" noWrap>
                {label}:
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Chip size="small" color="default" label={price || '-'} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Stack>
  );
};
